import { LegalPageLayout } from '../components/LegalPageLayout';
import { LegalSection } from '../components/LegalSection';
import { PARROT_CONNECT_PAY_TERMS } from '../../application/constants/legalDocuments';

/**
 * Página de Términos y Condiciones de ParrotConnectPay
 * Ruta: /legal/terms-pay
 */
export const ParrotConnectPayTerms = () => {
  return (
    <LegalPageLayout
      effectiveDate={PARROT_CONNECT_PAY_TERMS.effectiveDate}
      title="Términos y Condiciones - ParrotConnectPay"
      version={PARROT_CONNECT_PAY_TERMS.version}
    >
      {PARROT_CONNECT_PAY_TERMS.sections.map((section) => (
        <LegalSection content={section.content} key={section.id} table={section.table} title={section.title} />
      ))}
    </LegalPageLayout>
  );
};
